import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { Backend } from '@/_axios';
import messages from '@/resources/lang.json';
import merge from 'lodash.merge';
import moment from 'moment-timezone';
import stringTemplate from 'string-template';

import DatePicker from 'vue2-datepicker';
import dpEN from 'vue2-datepicker/locale/en';
import dpLV from 'vue2-datepicker/locale/lv';
// import dpRU from 'vue2-datepicker/locale/ru';

const vue2DatepickerLocales = {
  en: dpEN,
  lv: dpLV,
  // ru: dpRU,
};

const loadedLanguages = [];

Vue.use(VueI18n);
const defaultLang = 'en';
const lang = localStorage.Lang || defaultLang;

const i18n = new VueI18n({
  locale: lang, // set locale
  fallbackLocale: defaultLang,
  silentTranslationWarn: true,
  messages // set locale messages
});

function setI18nLanguage(lang) {
  i18n.locale = lang;
  if (vue2DatepickerLocales[lang]) DatePicker.locale(lang, vue2DatepickerLocales[lang]);
  moment.locale(i18n.locale);
  Backend.defaults.headers['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  localStorage.Lang = lang;
  return lang;
}

function loadLang(lang) {
  if (!Backend) return;
  if (loadedLanguages.includes(lang)) {
    setI18nLanguage(lang);
    return;
  }
  Backend.get(`/i18n/${lang}`).then((translations) => {
    loadedLanguages.push(lang);
    const map = merge(i18n.getLocaleMessage(lang), translations.data.map);
    i18n.setLocaleMessage(lang, map);
    setI18nLanguage(lang);
  });
}

Vue.prototype.$dt = (key, fallback, locale, values) => {
  let hasValues = typeof values === 'object';
  if (
    typeof locale === 'object'
    && !Array.isArray(locale)
    && locale !== null
  ) {
    values = locale;
    locale = i18n.locale;
    hasValues = true;
  }

  locale = locale || i18n.locale;
  if (!i18n.te(key)) return hasValues ? stringTemplate(fallback || key, values) : fallback || key; // todo allow passing values
  return i18n.t(key, locale, values);
};

Vue.prototype.$dtc = (key, fallback, choice, values) => {
  if (!i18n.tce(key)) return fallback || key; // todo allow passing values and choices
  return i18n.tc(key, choice, values);
};

// Used by scanner to automatically intercept keys
const $tk = function (key) {
  return key;
};
Vue.prototype.$tk = $tk;

export { i18n, loadLang, $tk };
